import React from "react"

import { graphql } from "gatsby"
import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"

import SharedHead from "@/components/SharedHead"
import useHeadTranslation from "@/hooks/use-head-translation"

import SupportTopicLandingLayout from "@/layouts/SupportTopicLanding"

export const Head = props => {
  const { t } = useHeadTranslation(props)

  return (
    <SharedHead
      {...props}
      title={t("support.topic.mobile-apps.name")}
      description={t("support.topic.mobile-apps.meta-description")}
    />
  )
}

const SupportMobileAppsPage = ({ data }) => {
  const { t } = useTranslation()

  return (
    <SupportTopicLandingLayout
      title={t("support.topic.mobile-apps.name")}
      articles={data.allSanitySupportDoc.nodes}
    />
  )
}

export const query = graphql`
  query ($language: String) {
    ...Locales

    allSanitySupportDoc(
      filter: {
        hidden: { ne: true }
        language: { eq: $language }
        topic: { eq: "mobile-apps" }
      }
    ) {
      nodes {
        _rawContent
        title
        slug {
          current
        }
        sortOrder
        isNew
      }
    }
  }
`

export default SupportMobileAppsPage
